import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, StoreUrl } from "../config/config";
import {
  AddLogoRequest,
  AddOrUpdateCategoryRequest,
  AddOrUpdateCategoryResponse,
  AddStoreRequest,
  DeleteCategoryRequest,
  DeleteLogoRequest,
  EditStoreRequest,
  Filter,
  GetCategoriesByStoreIdResponse,
  GetStoreListResponse,
  GetStoreResponse,
  IStoreID,
  StorePage,
} from "../models/store.model";

export const GetStoreList = (
  request: StorePage
): Promise<ApiResultModel<GetStoreListResponse[]>> => {
  return Axios.post<ApiResultModel<GetStoreListResponse[]>>(
    ApiBaseUrl + StoreUrl + "/GetStoreList",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetStoreListReportExcel = async (data: Filter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + StoreUrl + "/GetStoreListReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    response = response.data;
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ` فروشگاه ها.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const AddStore = (data: AddStoreRequest): Promise<boolean> => {
  const formData = new FormData();
  formData.append("IsActive", data.isActive.toString());
  formData.append("Title", data.title);
  formData.append("Logo", data.logo?.fileData!);
  formData.append("Banner", data.banner?.fileData!);
  formData.append(
    "SettlementDeadlineDays",
    data.settlementDeadlineDays.toString()
  );
  formData.append("SettlementPercentage", data.settlementPercentage.toString());
  formData.append("SortIndex", data.sortIndex.toString());
  formData.append("Description", data.description);
  formData.append("SortIndex", data.sortIndex.toString());
  // formData.append("WalletTypeIds", data.walletTypeIds);
  for (let i = 0; i < data.walletTypeIds.length; i++)
    formData.append("WalletTypeIds", data.walletTypeIds[i].toString());

  if (data.storeCategories) {
    for (let index = 0; index < data.storeCategories.length; index++) {
      const element = data.storeCategories[index];
      formData.append(`rawStoreCategories`, JSON.stringify(element));
    }
  }
  formData.append("StoreCategories", data.storeCategories.toString());
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + StoreUrl + "/AddStore",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};

export const AddLogo = (data: AddLogoRequest): Promise<boolean> => {
  const formData = new FormData();
  formData.append("StoreId", data.storeId.toString());
  formData.append("File", data.file.fileData!);
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + StoreUrl + "/AddLogo",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};

export const DeleteLogo = (
  request: DeleteLogoRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + StoreUrl + "/DeleteLogo",
    request
  ).then((result) => {
    return result.data;
  });
};

export const AddBanner = (data: AddLogoRequest): Promise<boolean> => {
  const formData = new FormData();
  formData.append("StoreId", data.storeId.toString());
  formData.append("File", data.file.fileData!);
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + StoreUrl + "/AddBanner",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data; charset=utf-8",
      },
    }
  ).then((result) => {
    return result.data.data;
  });
};
export const DeleteBanner = (
  request: DeleteLogoRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + StoreUrl + "/DeleteBanner",
    request
  ).then((result) => {
    return result.data;
  });
};
export const AddOrUpdateCategory = (
  request: AddOrUpdateCategoryRequest
): Promise<ApiResultModel<AddOrUpdateCategoryResponse>> => {
  return Axios.post<ApiResultModel<AddOrUpdateCategoryResponse>>(
    ApiBaseUrl + StoreUrl + "/AddOrUpdateCategory",
    request
  ).then((result) => {
    return result.data;
  });
};
export const DeleteCategory = (
  request: DeleteCategoryRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + StoreUrl + "/DeleteCategory",
    request
  ).then((result) => {
    return result.data;
  });
};
export const EditStore = (
  request: EditStoreRequest
): Promise<ApiResultModel<boolean>> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + StoreUrl + "/EditStore",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetStore = (
  request: IStoreID
): Promise<ApiResultModel<GetStoreResponse>> => {
  return Axios.post<ApiResultModel<GetStoreResponse>>(
    ApiBaseUrl + StoreUrl + "/GetStore",
    request
  ).then((result) => {
    return result.data;
  });
};

export const DeleteStore = (
  request: IStoreID
): Promise<ApiResultModel<string>> => {
  return Axios.post<ApiResultModel<string>>(
    ApiBaseUrl + StoreUrl + "/DeleteStore",
    request
  ).then((result) => {
    return result.data;
  });
};

export const GetCategoriesByStoreId = (
  data: IStoreID
): Promise<ApiResultModel<GetCategoriesByStoreIdResponse[]>> => {
  return Axios.get<ApiResultModel<GetCategoriesByStoreIdResponse[]>>(
    ApiBaseUrl + StoreUrl + "/GetCategoriesByStoreId/" + data.storeId
  ).then((result) => {
    return result.data;
  });
};
